import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c365a04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "section--body" }
const _hoisted_3 = { class: "time-wrapper" }
const _hoisted_4 = { class: "size" }
const _hoisted_5 = { class: "bold" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_8 = { class: "size" }
const _hoisted_9 = { class: "bold" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!

  return (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
    onHide: _ctx.hidePopUp,
    "hide-bottom-decoration": "",
    "hide-top-decoration": ""
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$localize('media.info.popup.type.folder')) + " " + _toDisplayString(_ctx.$localize('media.info.popup.type.info')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$localize('media.info.popup.file.folder')), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.fileAmount), 1),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$localize('media.info.popup.size')), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.mediaSize), 1),
              _hoisted_11
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onHide"]))
}